import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { convertCaseList, ConvertType } from '@/shared/utils/convertString'

import { IReviewItem, IReviewItemResponse } from '../types'

export const fetchKlassReview = async (courseId: string) => {
  const res = await axios.get<IReviewItemResponse>(
    `${process.env.NEXT_PUBLIC_API_ENDPOINT}/course/v1/reviews/${courseId}`,
  )

  return convertCaseList(res.data, ConvertType.CAMEL) as IReviewItem[]
}

export const useKlassReviewQuery = (courseId: string) => {
  return useQuery({
    queryKey: ['review', courseId],
    queryFn: () => fetchKlassReview(courseId),
  })
}
